<template>
  <div class="quote">
    <RegistrationQuoteBlockComponent
      :title="$tc('studea_manager.training.title', 1)"
      :data="trainingData"
      :isEditable="isEditable && isSpecificCalendarFormButtonActive"
      :actionTitle="$t('edit')"
      actionIcon="pen-to-square"
      action="getSpecificCalendarForm"
      :access="accessManager().EDIT"
      :accessCode="studeaManagerManager().STUDEA_MANAGER_REGISTRATION_FILL_CALENDAR"
      :loading="trainingLoading"
      @edit="edit"
    />
    <RegistrationQuoteBlockComponent
      :title="$t('registration.quote.contract')"
      :data="contract"
      :loading="contractLoading"
    />
    <RegistrationQuoteBlockComponent
      :title="$t('registration.quote.financial')"
      :data="finacial"
      :loading="financialLoading"
    />
    <RegistrationQuoteAmountBlockComponent
      :title="$t('registration.quote.amount')"
      :data="amount"
      :loading="amountLoading"
      :isEditable="isEditable"
      @editCost="editCost"
    />
  </div>
</template>

<script>
import RegistrationQuoteBlockComponent from "@/components/registration/quote/RegistrationQuoteBlockComponent.vue";
import RegistrationQuoteAmountBlockComponent from "@/components/registration/quote/RegistrationQuoteAmountBlockComponent.vue";
import { accessManager } from "@/services/security/access-manager";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";

export default {
  name: "RegistrationQuoteComponent",
  components: {
    RegistrationQuoteAmountBlockComponent,
    RegistrationQuoteBlockComponent,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    finacial: {
      type: Object,
      required: true,
    },
    amount: {
      type: Object,
      required: true,
    },
    trainingData: {
      type: Object,
      required: true,
    },
    financialLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    trainingLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    amountLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    contractLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpecificCalendarFormButtonActive: {
      type: Boolean,
      required: false,
      default: true,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["editDate", "editCost"],
  methods: {
    studeaManagerManager() {
      return studeaManagerManager;
    },
    accessManager() {
      return accessManager;
    },
    edit(payload) {
      this.$emit(payload);
    },
    editCost(cell) {
      this.$emit("editCost", cell);
    },
  },
};
</script>

<style lang="scss" scoped></style>
